import { useMultivariateExperiment } from '@/shared/features/multivariateexperiment/presentation/hooks/useMultivariateExperiment';
import { useState, useLayoutEffect } from 'react';
import { TAILWIND_MD_MIN_PX } from '@/shared/constants/breakpoints';

function getInitialColumns(): 2 | 3 {
  if (typeof window === 'undefined') return 2;
  return window.matchMedia(`(min-width: ${TAILWIND_MD_MIN_PX}px)`).matches ? 3 : 2;
}

/**
 * PLP grid columns: < 970px → 2, >= 970px → 3.
 * Seeds from window.matchMedia synchronously so the first client render
 * already has the correct column count — no useLayoutEffect re-render flash.
 */
export function usePlpColumns(mobileCardVariant?: 'V3' | 'V4'): 1 | 2 | 3 {
  const { plpVariant } = useMultivariateExperiment();
  const [columns, setColumns] = useState<2 | 3>(getInitialColumns);

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(`(min-width: ${TAILWIND_MD_MIN_PX}px)`);
    const handler = () => setColumns(mq.matches ? 3 : 2);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (mobileCardVariant ?? plpVariant) === 'V4' && columns === 2 ? 1 : columns;
}
